export default __webpack_public_path__ + "static/media/education-icon.7c636bcc.svg";